export default __webpack_public_path__ + "static/media/site.85ad120d.png";